<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>服务成果</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search-box">
            <el-form :inline="true" :model="formFilter" class="demo-form-inline" label-width="85px">
                <el-form-item label="项目名称">
                    <el-input placeholder="请输入项目名称" v-model="formFilter.project_name">
                    </el-input>
                </el-form-item>
                <el-form-item label="服务人员">
                    <el-input placeholder="请输服务人员" v-model="formFilter.name" style="width:300px" />
                </el-form-item>
                <el-form-item label="服务状态">
                    <el-select v-model="formFilter.service_status" placeholder="请选择服务状态">
                        <el-option label="全选" value=""></el-option>
                        <el-option :label="item" :value="key" v-for="(item, key) in  ServiceStatus" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="formFilter.status" placeholder="请选择状态">
                        <el-option label="全选" value=""></el-option>
                        <el-option :label="item" :value="key" v-for="(item, key) in subStatusList" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onFilter">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <div class="table" style="padding-top: 15px;">
                <el-table
                    :data="lists"
                    :border="true"
                    :stripe="true"
                >
                    <el-table-column
                        prop="k"
                        width="50"
                        align="center"
                        label="序号">
                    </el-table-column>
                    <el-table-column
                        prop="project_name"
                        align="center"
                        label="项目名称">
                    </el-table-column>
                    <el-table-column
                        label="记录时间"
                        align="center"
                        width="150"
                        prop="create_time">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        minWidth="250"
                        label="成果记录">
                        <template slot-scope="scope">
                            <div class="result-content">
                                <div class="text-content">{{ scope.row.content.text }}</div>
                                <div class="attachment-list">
                                    <div v-for="(pic, index) in scope.row.content.pics" :key="index" class="attachment-item" @click="anyPreview(pic.src)">
                                        <i class="el-icon-paperclip"></i>
                                        <span class="filename">{{ pic.filename }}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="80"
                        label="服务状态">
                        <template slot-scope="scope">
                            {{ServiceStatus[scope.row.service_status]}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        align="center"
                        width="80"
                        label="记录人">
                    </el-table-column>
                    <el-table-column
                        label="成果状态"
                        width="110"
                        align="center">
                        <template slot-scope="scope">
                            <div class="result-status-cell">
                                <span>{{subStatusList[scope.row.status]}}</span>
                                <el-tooltip
                                    v-if="scope.row.status === 3 && scope.row.remark"
                                    effect="light"
                                    placement="top"
                                    popper-class="result-status-tooltip"
                                >
                                    <span slot="content" class="result-status-tooltip__content">
                                        原因：{{ scope.row.remark }}
                                    </span>
                                    <i class="el-icon-warning-outline result-status-cell__icon"></i>
                                </el-tooltip>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                        width="150">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.status === 1" type="text" size="medium" @click="openReviewDialog(scope.row)">审核</el-button>
                            <el-button
                                v-if="scope.row.reset_status === 1"
                                type="text"
                                size="medium"
                                @click="openResetDialog(scope.row)"
                            >
                                重置状态
                            </el-button>
                            <el-button
                                type="text"
                                size="medium"
                                @click="goPage(`/index/project/serviceinfo?id=${scope.row.pid}&sub_id=${scope.row.sub_id}`)"
                            >
                                详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination" v-if="total_page > 1">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="20"
                        :current-page="currentPage"
                        @current-change="onPageChange"
                        :page-count="total_page">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="reviewDialogVisible" title="审核服务成果">
            <el-form :model="reviewForm" label-width="80px" label-position="left">
                <el-form-item label="审核结果">
                    <el-radio-group v-model="reviewForm.result">
                        <el-radio :label="2">通过</el-radio>
                        <el-radio :label="3">不通过</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="原因" v-if="reviewForm.result === 3">
                    <el-input
                        type="textarea"
                        v-model="reviewForm.remark"
                        :rows="4"
                        placeholder="请输入不通过原因，服务者可以查看并修改"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="reviewDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitReview">提交</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="resetDialogVisible" title="重置状态" width="420px">
            <p>重置后该成果将回到“待审核”状态，确认继续重置吗？</p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmResetStatus">确认重置</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { ServiceStatus } from '@/utils/STATUSLIST'

const subStatusList = ['已提交', '待审核', '已通过', '未通过']

export default {
    name: 'ServiceResults',
    inject: ['goPage', 'anyPreview'],
    data () {
        return {
            ServiceStatus,
            subStatusList,
            formFilter: {
                name: '',
                project_name: '',
                status: '',
                service_status: ''
            },
            lists: [],
            total_page: 1,
            reviewDialogVisible: false,
            reviewForm: {
                result: '',
                remark: ''
            },
            currentReviewItem: null,
            resetDialogVisible: false,
            currentResetItem: null
        }
    },
    computed: {
        ...mapState({
            currentPage: 'curPage',
            condition: 'formFilter'
        })
    },
    mounted () {
        // 获取路由参数
        const { project_name, status } = this.$route.query
        if (project_name) {
            this.formFilter.project_name = project_name
            this.$store.commit('changeCondition', this.formFilter)
        }
        if (status) {
            this.formFilter.status = +status
            this.$store.commit('changeCondition', this.formFilter)
        }
        if (this.condition) {
            this.formFilter = this.condition
        }
        this.getList()
    },
    methods: {
        onFilter () {
            this.$store.commit('changeCondition', this.formFilter)
            this.getList(1)
        },
        onPageChange (e) {
            this.$store.commit('changePage', e)
            this.getList(e)
        },
        getList (page = this.currentPage) {
            this.$http.get('/api/user/project/worklists', {
                params: {
                    page,
                    size: 20,
                    name: this.formFilter.name,
                    project_name: this.formFilter.project_name,
                    status: this.formFilter.status,
                    service_status: this.formFilter.service_status
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.lists = res.data.listData
                        this.total_page = res.data.total_page
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                    // this.$message.warning(res.message)
                })
        },
        openReviewDialog (item) {
            this.currentReviewItem = item
            this.reviewForm.result = 2
            this.reviewForm.remark = ''
            this.reviewDialogVisible = true
        },
        submitReview () {
            if (this.reviewForm.result === 3 && !this.reviewForm.remark) {
                this.$message.warning('请填写不通过原因')
                return
            }
            if (this.reviewForm.result === 2) {
                this.reviewForm.remark = ''
            }
            this.$http.post('/api/user/project/verifyservicework', {
                work_id: this.currentReviewItem.id,
                status: this.reviewForm.result,
                remark: this.reviewForm.remark
            })
                .then(res => {
                    if (res.code === 0) {
                        this.$message.success('审核成功')
                        this.reviewDialogVisible = false
                        this.getList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        openResetDialog (item) {
            this.currentResetItem = item
            this.resetDialogVisible = true
        },
        confirmResetStatus () {
            if (!this.currentResetItem) {
                return
            }
            this.$http.post('/api/user/project/resetservicework', {
                work_id: this.currentResetItem.id
            })
                .then(res => {
                    if (res.code === 0) {
                        this.$message.success('状态已重置为待审核')
                        this.resetDialogVisible = false
                        this.getList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/sub.scss";
.attachment-list {
    padding: 5px 0;
    .attachment-item {
        padding: 4px 8px;
        margin: 2px;
        color: #4B74FF;
        font-size: 14px;
        cursor: pointer;
        display: inline-block;
        line-height: 1.2;
        i {
            position: relative;
            top: 1px;
        }
        .filename {
            font-size: 12px;
            margin-left: 4px;
            text-decoration: underline;
        }
    }
}
.result-status-cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    .result-status-cell__icon {
        color: #FF525B;
        margin-left: 4px;
        cursor: pointer;
        font-size: 14px;
    }
}
.result-status-tooltip {
    background: #fff !important;
    color: #303133 !important;
    border: 1px solid #e4e7ed !important;
    padding: 8px 12px !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08) !important;
    .popper__arrow {
        border-top-color: #e4e7ed !important;
        &::after {
            border-top-color: #fff !important;
        }
    }
}
.result-status-tooltip__content {
    display: block;
    max-width: 260px;
    line-height: 1.4;
    white-space: normal;
}
</style>
